export default __webpack_public_path__ + "static/media/Mehfooz-ur-Rehman_CV.20f1582f.docx";